
import { apiUrl } from '../ui-utils/apiConfig'
import { httpRequest } from '../ui-utils/api'

const taskDetails = async (customerEmail, dispatch) => {
    // srini - 14/11/24
    if(customerEmail && customerEmail.includes("@") && customerEmail.includes(".")){
        try {
            const taskData = await httpRequest({
                
                endPoint: `${apiUrl.customerEmail}/${customerEmail}`,
                method: "get",
                instance: "instanceOne",
            })

            if (taskData.success) {
                dispatch({
                    type: 'SET_CALL_HISTORY',
                    payload: taskData.data.msg
                })
            }
            // Dev Srini 25/10/24
            else{
                console.log('Error in Task Details API', taskData)
            }
        }
        catch (error) {
            console.log('Error in Task Details API', error)
        }
    }
}

export default taskDetails